import { Box, Fade, Slide } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PromoLanding from './PromoLanding';
import { AppTour } from './AppTour';

export const PromoIndex = ({ plan }) => {
  const [showPromo, setShowPromo] = useState(true);
  const [step, setStep] = useState(0);

  const [userId, setUserId] = useState('');

  return (
    <Fade in={showPromo}>
      <Box>
        <Fade mountOnEnter unmountOnExit in={step == 0} timeout={1000}>
          <div>
            {step === 0 && (
              <PromoLanding setStep={setStep} setUserId={setUserId} />
            )}
          </div>
        </Fade>
        <Slide direction='left' mountOnEnter unmountOnExit in={step == 1}>
          <div>{step === 1 && <AppTour userId={userId} />}</div>
        </Slide>
      </Box>
    </Fade>
  );
};
